import React from "react";
import { UserRoundCheck, ShoppingCart, MailCheck } from "lucide-react";

const ICON_COLOR_DEFAULT = "white";

const ICONS = {
  LEAD_SOURCE: <UserRoundCheck size={40} stroke={ICON_COLOR_DEFAULT} />,
  ECOMMERCE_SOURCE: <ShoppingCart size={38} stroke={ICON_COLOR_DEFAULT} />,
  ZAPIER_SOURCE: <MailCheck size={38} stroke={ICON_COLOR_DEFAULT} />,
  CUSTOM_SOURCE: <MailCheck size={38} stroke={ICON_COLOR_DEFAULT} />,
};


const SocialProofSVG = ({ styles, svg }) => {
  const stylesJSON = styles.toJS();

  return (
    <div className="sumome-react-wysiwyg-component bdow-sp-icon-svg" style={stylesJSON}>
      {ICONS[svg]}
    </div>
  );
}

export default SocialProofSVG;